import $ from 'jquery'

$(document).ready(function() {
	$('#headerSearchForm .search-icon').click(function() {
		$('#headerSearchForm').submit()
	})
	reposHeaderSide()
})

const $headerSide = $('#site-header-side')
const reposHeaderSide = () => {
	$(window).width() < 768
		? $headerSide.appendTo('#site-navigation')
		: $headerSide.appendTo('#masthead')
}

export default reposHeaderSide
